import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        height: 100%;
        min-height: 100%;
        padding: 0rem;
    }

    .header {
    }

    .body {
        padding: 0 5px 10px 5px;
        margin-top: 0.6rem;
        overflow-y: auto;
        flex: 1;
        min-height: 2em;
    }

    .footer {
        padding-top: 0.5rem;
    }

    .visible {
        display: block;
    }
    .hidden {
        display: none;
    }
`;
